import { colors, images } from '../../utils'

const useStyles = () => {
  return {
    container: {
      width: '100vw',
      height: '100vh',
      background: `url(${images.background})`,
      backgroundSize: '100vw 100vh',
      backgroundRepeat: 'no-repeat',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    formContainer: {
      width: { xl: '430px', lg: '430px', md: '430px', sm: '90%', xs: '90%' },
      padding: { xs: '24px 0px 16px', md: '60px 0px 20px' },
      background: colors.white,
      borderRadius: '10px',
      height: { xs: 'auto', md: 'calc(100vh - 100px)' },
      maxHeight: { xs: 'none', md: '520px' },
    },
    colorText: {
      color: colors.lightPrimary,
      fontWright: '500',
    },
    title: {
      fontSize: { xs: '16px', md: '35px' },
    },
    subtitle: {
      fontSize: { xs: '18px', md: '30px' },
    },
    containerChildren: {
      // margin: '20px 0px',
    },
    body: {
      width: { xs: 'calc(100% - 32px)', md: 'calc(100% - 80px)' },
      height: { xs: 'auto', md: 'calc(100% - 80px)' },
      overflowY: 'auto',
      padding: { xs: '0 16px', md: '0 40px' },
    },
    return: {
      width: 'fit-content',
    },
    containerLogo: (data) => {
      return {
        marginTop: '20px',
        display: 'flex',
        padding: '0 40px',
        justifyContent: 'end',
        alignItems: 'center',
        '& img': {
          cursor: !data?.cursor ? 'pointer' : data?.cursor,
          width: '130px',
          height: '55px',
        },
      }
    },
  }
}

export { useStyles }
